"use client";

import { Toaster as ChakraToaster, Portal, Spinner, Stack, Toast, createToaster } from "@chakra-ui/react";
import {
    CheckmarkCircleSolidIcon,
    NoEntryIcon,
    WarningTriangleSolidIcon,
    InfoCircleIcon
} from "@digital-services-gard-as/anchor-icons";
export const toaster = createToaster({
    placement: "top",
    pauseOnPageIdle: true
});

type ToastVariant = "info" | "success" | "error" | "warning" | "loading";

type StyleConfig = {
    background: string;
    color: string;
    icon: React.ReactNode;
};

const styleMap: Record<ToastVariant, StyleConfig> = {
    info: {
        background: "anchor.navy.900",
        color: "white",
        icon: <InfoCircleIcon />
    },
    success: {
        background: "anchor.green.700",
        color: "white",
        icon: <CheckmarkCircleSolidIcon />
    },
    error: {
        background: "anchor.red.800",
        color: "white",
        icon: <NoEntryIcon />
    },
    warning: {
        background: "anchor.yellow.900",
        color: "black",
        icon: <WarningTriangleSolidIcon />
    },
    loading: {
        background: "anchor.navy.900",
        color: "white",
        icon: <Spinner size="sm" />
    }
};

export const Toaster = () => {
    return (
        <Portal>
            <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
                {toast => {
                    const type = (toast.type ?? "info") as ToastVariant;
                    const { background, color, icon } = styleMap[type] || styleMap.info;
                    return (
                        <Toast.Root
                            width={{ md: "sm" }}
                            backgroundColor={background}
                            color={color}
                            data-testid={`toast-${toast.id}`}
                        >
                            {toast.type === "loading" ? <Spinner size="sm" color="blue.solid" /> : icon}
                            <Stack gap="1" flex="1" maxWidth="100%">
                                {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                                {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
                            </Stack>
                            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
                            {toast.closable && <Toast.CloseTrigger />}
                        </Toast.Root>
                    );
                }}
            </ChakraToaster>
        </Portal>
    );
};
